export const WELCOME_USER_AS_ACTOR_COPY =
  'You connect your sources; OwnYou never connects them for you.';

export const WELCOME_SPLASH_COPY = {
  eyebrow: 'Welcome',
  title: 'Welcome to OwnYou',
  actor: WELCOME_USER_AS_ACTOR_COPY,
  body: 'Start with identity, then choose a real source so missions have data to work from.',
  primaryAction: 'Start setup',
} as const;

export const WELCOME_BANNED_TRUST_CLAIM_PATTERNS: readonly RegExp[] = [
  /\bSOC\s*2\b/i,
  /\bcertifi(?:ed|cation)\b/i,
  /\baudit(?:ed|or|s)?\b/i,
  /\bnever\s+train\b/i,
  /\bencryption[-\s]?at[-\s]?rest\b/i,
  /\bencrypted\s+at\s+rest\b/i,
];

export interface WelcomeCopyLintResult {
  ok: boolean;
  violations: string[];
  hasActorFraming: boolean;
}

export function lintWelcomeTrustCopy(text: string): WelcomeCopyLintResult {
  const violations = WELCOME_BANNED_TRUST_CLAIM_PATTERNS
    .filter(pattern => pattern.test(text))
    .map(pattern => pattern.source);
  const hasActorFraming = text.includes(WELCOME_USER_AS_ACTOR_COPY);

  return {
    ok: violations.length === 0 && hasActorFraming,
    violations,
    hasActorFraming,
  };
}

export function getWelcomeSplashVisibleCopy(): string {
  return [
    WELCOME_SPLASH_COPY.eyebrow,
    WELCOME_SPLASH_COPY.title,
    WELCOME_SPLASH_COPY.actor,
    WELCOME_SPLASH_COPY.body,
    WELCOME_SPLASH_COPY.primaryAction,
  ].join(' ');
}
